/**
 * App Mode Configuration
 * Defines features available in each mode
 */

export const APP_MODES = {
  standard: {
    id: 'standard',
    name: 'Standard',
    description: 'Document automation for individuals and businesses',
    features: [
      'docx_templates',
      'pdf_templates',
      'template_runs',
      'global_fields',
      'categories',
      'marketplace',
    ],
  },
  crm: {
    id: 'crm',
    name: 'CRM',
    description: 'Complete practice management for California Family Law firms',
    features: [
      // All standard features
      'docx_templates',
      'pdf_templates', 
      'template_runs',
      'global_fields',
      'categories',
      // CRM-specific features
      'firm_profile',
      'clients',
      'cases',
      'courts',
      'forms',
      'opposing_counsel',
      'crm_dashboard',
      'document_assembly',
      'calendar',
    ],
  },
};

/**
 * Navigation items for each mode
 */
export const NAVIGATION = {
  standard: [
    { id: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
    { id: 'templates', label: 'Templates', path: '/templates', icon: 'FileText' },
    { id: 'runs', label: 'Runs', path: '/runs', icon: 'Play' },
    { id: 'global-fields', label: 'Global Fields', path: '/global-fields', icon: 'Database' },
    { id: 'categories', label: 'Categories', path: '/categories', icon: 'Tags' },
    { id: 'marketplace', label: 'Marketplace', path: '/marketplace', icon: 'Store' },
  ],
  crm: [
    { id: 'dashboard', label: 'Dashboard', path: '/dashboard', icon: 'LayoutDashboard' },
    { id: 'clients', label: 'Clients', path: '/clients', icon: 'Users' },
    { id: 'cases', label: 'Cases', path: '/cases', icon: 'Briefcase' },
    { 
      id: 'manage', 
      label: 'Manage', 
      icon: 'Settings',
      isGroup: true,
      items: [
        { id: 'firm', label: 'Firm Profile', path: '/firm', icon: 'Building2' },
        { id: 'courts', label: 'Courts', path: '/courts', icon: 'Building2' },
        { id: 'opposing-counsel', label: 'Opposing Counsel', path: '/opposing-counsel', icon: 'UserX' },
        { id: 'templates', label: 'Templates', path: '/templates', icon: 'FileText' },
        { id: 'runs', label: 'Documents', path: '/runs', icon: 'FileOutput' },
        { id: 'global-fields', label: 'Global Fields', path: '/global-fields', icon: 'Database' },
      ]
    },
  ],
};

/**
 * Check if a feature is available in the given mode
 */
export const hasFeature = (mode, feature) => {
  const modeConfig = APP_MODES[mode];
  return modeConfig?.features?.includes(feature) || false;
};

/**
 * Get navigation items for a mode
 */
export const getNavigation = (mode) => {
  return NAVIGATION[mode] || NAVIGATION.standard;
};

export default APP_MODES;
